<template>
  <div class="CNV publicLess">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoad"
      class="van-load"
    >
      <div class="null-box" v-if="isEmpty">
        <van-empty
          class="custom-image"
          image-size="100px"
          :image="require('../../../../assets/not.png')"
          description="未检出"
        />
      </div>
      <div v-else>
        <div
          class="cnv-list publicLess-list"
          v-for="(item, index) in list"
          :key="index"
        >
          <h1 @click="geneClick(item)">{{ item.gene }}</h1>
          <div class="show-box"></div>
          <div class="data-box">
            <div class="left">
              <div>
                <p>变异倍数</p>
                <h4>{{ item.cnvMultiple }}</h4>
              </div>
              <div>
                <p>起始位置</p>
                <h2>{{ item.startPosition }}</h2>
              </div>
              <div>
                <p>变异类型</p>
                <h2>{{ item.cnvResult }}</h2>
              </div>
            </div>
            <div class="right">
              <div>
                <p>染色体</p>
                <h2>{{ item.chromosome }}</h2>
              </div>
              <div>
                <p>终止位置</p>
                <h2>{{ item.endPosition }}</h2>
              </div>
              <div v-if="$route.query.userAgent != 'wxWeb'">
                <p>相同变异患者</p>
                <h3 @click="byClick(item)">{{ item.cohort }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { cnvData } from "@/api/reportQuery";
import { handleSearch } from "@/utils/search";
import { Toast } from "vant";
import { mapState } from "vuex";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    searchVal: {
      type: String,
    },
  },
  name: "CNV",
  data() {
    return {
      isEmpty: false,
      loading: false,
      finished: false,
      mutationData: [],
      list: [],
      searchData: [],
      badge: "",
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    this.getCnv();
  },

  watch: {
    searchVal: function (val) {
      if (!val) {
        this.clearSearch();
      }
    },
  },
  methods: {
    // 相同变异患者点击事件
    byClick(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        wdName: item.cohort,
        gene: item.gene,
        proteinChange: "",
        tabIndex: "1",
        Jump: "1",
        fromSource: "cnv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 基因点击事件
    geneClick(item) {
      var num = "0";
      let param = {
        name: "wdJiedu",
        type: num,
        gene: item.gene,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "cnv",
        webId: "BGXQ-TXBBYJG",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/gene-jiedu/gene-jiedu?gene=" + item.gene,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    clearSearch() {
      this.list = this.searchData;
      this.finished = false;
      this.isEmpty = false;
    },
    searchFn() {
      /**搜索查询的方法 */
      if (this.searchVal) {
        this.list = handleSearch(this.searchVal, this.mutationData);
        if (this.searchVal != "" && this.list.length === 0) {
          this.isEmpty = true;
        }
      }
    },
    getCnv() {
      this.loading = true;
      this.$nextTick(async () => {
        try {
          let { data } = await cnvData({
            labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
            productId: this.publicParams.productId,
          });
          this.mutationData = data;
          this.list = this.mutationData;
          this.searchData = this.mutationData;
          if (data == "") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          // this.badge = data.length;
          // if (this.badge > 100) {
          //   this.badge = 99 + "+";
          // }
          // this.$emit("badge-cnv", this.badge);
          this.loading = false;
          console.log(this.mutationData);
          if (this.mutationData.length > 0) return (this.loading = false);
        } catch (error) {
          console.log(error);
        }
      });
    },
    onLoad() {
      this.loading = false;

      // 异步更新数据
      // if (this.mutationData.length == 0) {
      //   console.log("11111=====");
      //   this.finished = true;
      // } else {
      //   if (this.list.length < 10) {
      //     this.list = this.mutationData;
      //     this.searchData = this.mutationData;
      //   } else {
      //     for (let i = 0; i < 10; i++) {
      //       this.list.push(this.mutationData[i]);
      //       this.searchData.push(this.mutationData[i]);
      //     }
      //   }

      //   console.log(this.list);
      //   // console.log(this.list)
      //   // 加载状态结束
      //   // 数据全部加载完成
      //   if (this.list.length >= this.mutationData.length) {
      //     this.finished = true;
      //   }
      // }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./styles/index.less";
</style>
